import { NextRouter } from "next/router";
// import consts from "src/config/consts";

export default function addParamsToQuery(
  router: NextRouter,
  params: { name: string; value: string }[]
) {
  const { query } = router;

  // // remove old variant options from query
  // for (const option of consts.VARIANT_OPTIONS) {
  //   delete query[option];
  // }

  // add passed option to the query
  params.forEach((param) => {
    query[param.name] = param.value;
  });

  // join params as one string
  const queryParams = Object.entries(query)
    .map(
      ([name, value]) =>
        `${name}=${
          typeof value === "string" ? encodeURIComponent(value) : value
        }`
    )
    .join("&");

  // Get basepath
  let basePath = router.asPath;
  const questionIndex = router.asPath.indexOf("?");
  if (questionIndex) {
    basePath = router.asPath.slice(0, questionIndex);
  }

  router.replace(`${basePath}?${queryParams}`, undefined, {
    shallow: true,
    scroll: false,
  });
}
